/** Makes inline diagram SVGs scale with their container and page zoom. */
export function normalizeResponsiveSvg(svg: string): string {
  if (!svg.trim().startsWith('<svg')) return svg;

  return svg.replace(/<svg\b([^>]*)>/i, (_match, attrs: string) => {
    let next = attrs
      .replace(/\s+width\s*=\s*["'][^"']*["']/gi, '')
      .replace(/\s+height\s*=\s*["'][^"']*["']/gi, '');

    if (!/preserveAspectRatio\s*=/i.test(next)) {
      next += ' preserveAspectRatio="xMidYMid meet"';
    }

    next += ' width="100%" height="auto"';
    return `<svg${next}>`;
  });
}
